'use client';

import useSWR from 'swr';
import { investmentsApi } from '@/lib/api';
import type { InvestmentItem } from '@/types';
import { useAuthedFetcher } from './swrConfig';

/**
 * Ungrouped positions the manual picker can group the anchor with, searched across the WHOLE
 * portfolio rather than the current list page. Keyed on the query so typing re-fetches; the null
 * key while `enabled` is false keeps it idle until the picker opens.
 */
export function useGroupingCandidates(enabled: boolean, query: string) {
  const authedFetch = useAuthedFetcher();
  const q = query.trim();

  return useSWR<InvestmentItem[]>(
    enabled ? ['grouping-candidates', q] : null,
    () => authedFetch((token) => investmentsApi.getGroupingCandidates(token, q || undefined)),
    { keepPreviousData: true },
  );
}
